import {
  faObjectsAlignBottom,
  faObjectsAlignCenterHorizontal,
  faObjectsAlignTop
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import { useEditorState } from '@tiptap/react'
import clsx from 'clsx'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { editorDropdownItem, editorDropdownItemActive } from './EditorInput.css'
import { SplitButtonDropdown } from './SplitButtonDropdown'

export const VerticalAlignDropdown = ({ editor }: { editor: Editor }) => {
  const editorState = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isTop: editor.isActive({ verticalAlign: 'top' }),
      isMiddle: editor.isActive({ verticalAlign: 'middle' }),
      isBottom: editor.isActive({ verticalAlign: 'bottom' })
    })
  })

  const activeIcon = editorState.isBottom
    ? faObjectsAlignBottom
    : editorState.isMiddle
      ? faObjectsAlignCenterHorizontal
      : faObjectsAlignTop

  return (
    <Tooltip direction="bottom" text="Alignement vertical" asChild>
      <SplitButtonDropdown
        isActive={editorState.isMiddle || editorState.isBottom}
        icon={<FontAwesomeIcon icon={activeIcon} />}
        onMainClick={() =>
          editor.chain().focus().setCellAttribute('verticalAlign', 'top').run()
        }
      >
        <button
          type="button"
          className={clsx(
            editorDropdownItem,
            editorState.isTop && editorDropdownItemActive
          )}
          onClick={() =>
            editor
              .chain()
              .focus()
              .setCellAttribute('verticalAlign', 'top')
              .run()
          }
        >
          <FontAwesomeIcon icon={faObjectsAlignTop} />
          Haut
        </button>
        <button
          type="button"
          className={clsx(
            editorDropdownItem,
            editorState.isMiddle && editorDropdownItemActive
          )}
          onClick={() =>
            editor
              .chain()
              .focus()
              .setCellAttribute('verticalAlign', 'middle')
              .run()
          }
        >
          <FontAwesomeIcon icon={faObjectsAlignCenterHorizontal} />
          Milieu
        </button>
        <button
          type="button"
          className={clsx(
            editorDropdownItem,
            editorState.isBottom && editorDropdownItemActive
          )}
          onClick={() =>
            editor
              .chain()
              .focus()
              .setCellAttribute('verticalAlign', 'bottom')
              .run()
          }
        >
          <FontAwesomeIcon icon={faObjectsAlignBottom} />
          Bas
        </button>
      </SplitButtonDropdown>
    </Tooltip>
  )
}
